import { createContext, useContext } from "react";
import { useGet } from "../../components-system/api";
import { usePost } from "../../components-system/api/use-post.hook";
import { usePut } from "../../components-system/api/use-put.hook";
import { useDelete } from "../../components-system/api/use-delete.hook";
import { DataSource } from "../_types";

export type FormContextType = {
  get: (source: DataSource) => ReturnType<typeof useGet>;
  create: ReturnType<typeof usePost>;
  save: ReturnType<typeof usePut>;
  delete: ReturnType<typeof useDelete>;
};

// Create the form context
export const FormContext = createContext<FormContextType | undefined>(undefined);

// Hook to use the form context
export const useForm = () => {
  const context = useContext(FormContext);
  if (context === undefined) {
    throw new Error('useForm must be used within a FormProvider');
  }
  return context;
};
